import { css } from 'linaria';

export const currentStorySlide = css`
  && {
    width: 180px;
    height: 224px;
    margin-right: 20px;

    @media (--only-tablet) {
      width: 138px;
      height: 176px;
      margin-right: 16px;
    }

    @media (--only-mobile) {
      width: 128px;
      height: 162px;
      margin-right: 12px;
    }
  }
`;

export const currentStoryCard = css`
  position: relative;
`;

export const currentStoryImage = css`
  width: 180px;
  height: 224px;
  border-radius: var(--rounding-l);
  object-fit: cover;

  @media (--only-tablet) {
    width: 138px;
    height: 176px;
  }

  @media (--only-mobile) {
    width: 128px;
    height: 162px;
    border-radius: var(--rounding-m);
  }
`;

export const currentStoryCardName = css`
  && {
    position: absolute;
    top: 16px;
    left: 16px;
    right: 16px;

    @media (--to-desktop) {
      top: 12px;
      left: 12px;
      right: 12px;
      font-size: 12px;
      line-height: 16px;
    }
  }
`;
